export const appHeaderHeight = "56px"

export const whitePure = ["white", "pure"]

export const redOrange = ["red", "redOrange"]
export const redOutrageousOrange = ["red", "outrageousOrange"]
export const redRoseWhite = ["red", "roseWhite"]

export const yellowSafron = ["yellow", "safron"]
export const yellowSafronMango = ["yellow", "safronMango"]

export const greenHaze = ["green", "greenHaze"]
export const greenMalachite = ["green", "malachite"]
export const greenClearDay = ["green", "clearDay"]

export const grayBombay = ["gray", "bombay"]
export const grayLimedSpruce = ["gray", "limedSpruce"]
export const graySilverSand = ["gray", "silverSand"]
export const grayGallery = ["gray", "gallery"]

export const dangerColor = ["danger"]
export const borderColor = ["borderColor"]
export const textColor = ["text"]
export const errorColor = ["error"]
export const successColor = ["success"]
export const warningColor = ["warning"]
